import React from "react";
import ReactDOM from "react-dom";
import qs from "qs";
import { MonetaryAmount } from "../../../app/domain/monetary-amount";
import { translate } from "../../../infrastructure/translate/localization";
import { findCompanyId } from "../../../infrastructure/repository/company-repository";
import { getConsumptionsData } from "../../../infrastructure/repository/reports-repository";
import ConsumptionsBlock from "../components/AnalyticsPage/components/ConsumptionsBlock";
import { getBlockProps } from "../components/AnalyticsPage/utils";
import { showErrorMessage } from "../../commons/show-error-message";

export function renderConsumptionsBlock(props) {
  if (document.getElementById("consumptions-block")) {
    ReactDOM.render(
      <ConsumptionsBlock {...props} />,
      document.getElementById("consumptions-block")
    );
  }
}

export async function displayConsumptionsBlock({ filters }) {
  renderConsumptionsBlock({ isLoading: true });

  const companyId = await findCompanyId();
  try {
    const { data } = await getConsumptionsData({
      companyId,
      filters: qs.stringify(filters),
    });

    renderConsumptionsBlock({
      currentFilters: filters,
      consumptionsData: data.data,
      monthlyConsumptionsData: getBlockProps({
        data: data.data,
        property: "monthlyConsumptions",
        formatFunction: (amountInCents) =>
          MonetaryAmount.ofCurrency({
            amountInCents,
            currency: data.data.currency,
          }).prettifyMoney({}),
        invertTags: true,
        addMonths: -1,
      }),
      consumptionsPerPersonData: getBlockProps({
        data,
        property: "consumptionsPerPerson",
        formatFunction: (amountInCents) =>
          MonetaryAmount.ofCurrency({
            amountInCents,
            currency: data.data.currency,
          }).prettifyMoney({}),
        invertTags: true,
        addMonths: -1,
      }),
    });
  } catch (error) {
    showErrorMessage(translate("common-messages.basic-error-message"));
  }
}
